import { render, staticRenderFns } from "./debt-relief-offers-2.vue?vue&type=template&id=be2e5806"
import script from "./debt-relief-offers-2.vue?vue&type=script&lang=js"
export * from "./debt-relief-offers-2.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/a11yModal.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./debt-relief-offers-2.vue?vue&type=style&index=1&id=be2e5806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports